import React, { useState, useEffect } from "react";

import { ReactComponent as Spinner } from "../../_assets/imgs/spinner-solid.svg";

import "./keyboard-diagnostic.styles.css";

const KeyboardDiagnostic = ({ status, index, changeDiagnosticResults }) => {
  const [isInputDissabled, setIsInputDissabled] = useState(true);
  const [testInput, setTestInput] = useState({ keyboardInput: "" });

  useEffect(() => {
    if (status === "error" || status === "successful" || status === "pending")
      return;
    setIsInputDissabled(false);
  }, [status]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (event) => {
    setTestInput({
      ...testInput,
      [event.target.name]: event.target.value,
    });
  };

   useEffect(() => {
    const { keyboardInput } = testInput;
    if (keyboardInput.toLowerCase() === "hello") {
      changeDiagnosticResults(index, "working", "successful");
      setIsInputDissabled(true);
    }
  },[testInput]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="diagnostic-details-wrapper">
      <span>
        {status === "running" && <Spinner className="diagnostic-spinner" />}
      </span>
      {status === "successful" && (
        <span className="diagnostic-tick">&#10003;</span>
      )}
      {status === "error" && <span className="diagnostic-error">!</span>}
      <div>
        <span className="diagnostic-test-heading">Keyboard Test</span>
        <span>Please type "Hello" below:</span>
        <div>
            <input
              className="keyboard-diagnosis-input"
              type="text"
              disabled={isInputDissabled}
              name="keyboardInput"
              onChange={handleChange}
            />
        </div>
      </div>
    </div>
  );
};

export default KeyboardDiagnostic;
